import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { Column } from '../../../../../../../CommonComponents/OPL/Grid/Column';
import { Grid } from '../../../../../../../CommonComponents/OPL/Grid/Grid';
import { Row } from '../../../../../../../CommonComponents/OPL/Grid/Row';
import { Input } from '../../../../../../../CommonComponents/OPL/Input/Input';
import { InputNumberMask } from '../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormValues } from '../../../../MySettings.meta';

interface Props {
  formBag: UseFormReturn<FormValues>;
}

export const ContactInfoForm: React.FC<Props> = ({ formBag }) => {
  const {
    formState: { errors },
  } = formBag;
  return (
    <Grid>
      <Row mb="32">
        <Column width={6}>
          <Input
            {...formBag.register('firstName')}
            label="First Name"
            type="text"
            formVariant={errors.firstName ? 'error' : undefined}
            helperText={errors.firstName?.message}
            autoComplete="given-name"
          />
        </Column>

        <Column width={6}>
          <Input
            {...formBag.register('lastName')}
            label="Last Name"
            type="text"
            autoComplete="family-name"
          />
        </Column>
      </Row>

      <Row mb="32">
        <Column width={6}>
          <Input
            {...formBag.register('email')}
            label="Email"
            type="text"
            formVariant={errors.email ? 'error' : undefined}
            helperText={errors.email?.message}
            autoComplete="email"
          />
        </Column>

        <Column width={6}>
          <Controller
            control={formBag.control}
            name="phoneNumber"
            render={({ field: { value } }) => (
              <InputNumberMask
                label="Phone Number"
                value={value}
                format="(###) ###-####"
                type="tel"
                onValueChange={({ formattedValue }) => {
                  formBag.setValue('phoneNumber', formattedValue, { shouldDirty: true });
                }}
              />
            )}
          />
        </Column>
      </Row>

      <Row>
        <Column width={12}>
          <Input
            {...formBag.register('calendarUrl')}
            label="Calendar URL"
            type="text"
            formVariant={errors.calendarUrl ? 'error' : undefined}
            helperText={errors.calendarUrl?.message}
          />
        </Column>
      </Row>
    </Grid>
  );
};
